module.exports = __webpack_public_path__ + "static/media/missing-data-icon.019096e3.webp";